var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.imgPreview.visible)?_c('el-image-viewer',{attrs:{"zIndex":9999,"on-close":_vm.closeImgViewer,"url-list":_vm.imgPreview.imgs}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }